import axios from "axios"
import { getRestApiBaseUrl } from "../utils/restApiBaseUrl"
import { RegistrarLogErro } from "./clientefiel"
import { getVisitorId } from "./visitorId"

const api = axios.create({
    baseURL: getRestApiBaseUrl(),
})

api.interceptors.request.use(config => {
    try {
        config.headers.common["sistema"] = "painel"

        const windowName = window.name
        if (windowName) config.headers.common["identificador"] = windowName

        // Loja selecionada no painel (troca de estabelecimento). O backend usa este header para
        // resolver o "estabelecimento em uso" (getEstabelecimentoEmUso) e respeitar a troca de loja
        // — que hoje muda apenas no front, sem alterar a credencial. Os fluxos de operacao de pedidos
        // (receber pedidos e registrador) definem a loja por outros meios e ignoram este header.
        try {
            const estabAtual = JSON.parse(localStorage.getItem("estabelecimentoAtualCF"))
            if (estabAtual?.id) config.headers.common["estabelecimento"] = estabAtual.id
        } catch (_) {}

        try {
            config.headers.common["X-Visitor-Id"] = getVisitorId()
        } catch (_) {}

        return config
    } catch (error) {
        RegistrarLogErro(error, "API Interceptor", { config })

        return config
    }
})

// ── Tratamento global de 401 ──────────────────────────────────────────────
// Ao receber 401, tenta revalidar a sessão com a credencial salva (chaveSistema)
// via LoginFornecedorAutomatico. Se a credencial ainda for válida, refaz a
// requisição original; caso contrário, desloga e manda o usuário para /login.

let reloginPromise = null
let redirecionandoParaLogin = false

async function revalidarSessaoSalva() {
    const chave = localStorage.getItem("chaveSistema")
    if (!chave) return false

    try {
        const response = await api.post(
            "fornecedor/LoginFornecedorAutomatico",
            {},
            {
                headers: { "Content-Type": "application/json", authorization: chave },
                // evita recursão: a própria chamada de revalidação não passa pelo interceptor 401
                _pularInterceptor401: true,
            }
        )
        const data = response?.data
        return !(typeof data === "string" || !data || data.codErro > 0)
    } catch (error) {
        return false
    }
}

function deslogarERedirecionar() {
    if (redirecionandoParaLogin) return
    redirecionandoParaLogin = true

    localStorage.removeItem("chaveSistema")
    localStorage.removeItem("dataUltimoServico")
    localStorage.removeItem("estabelecimentoAtualCF")
    window.name = ""

    if (!window.location.pathname.includes("/login")) {
        window.location.assign("/login")
    }
}

api.interceptors.response.use(
    response => response,
    async error => {
        const status = error?.response?.status
        const config = error?.config

        // só trata 401; ignora chamadas já reprocessadas e a própria revalidação
        if (status !== 401 || !config || config._pularInterceptor401 || config._retry401) {
            return Promise.reject(error)
        }

        config._retry401 = true

        // uma única revalidação por vez, compartilhada entre requisições concorrentes
        if (!reloginPromise) {
            reloginPromise = revalidarSessaoSalva().finally(() => {
                reloginPromise = null
            })
        }

        const sessaoValida = await reloginPromise

        if (sessaoValida) {
            const chave = localStorage.getItem("chaveSistema")
            if (chave && config.headers) {
                config.headers.Authorization = chave
            }
            return api(config)
        }

        deslogarERedirecionar()
        return Promise.reject(error)
    }
)

export default api
